/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 提取失败照片查看弹窗
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-02-09 12:10:00
 */

import React, { useEffect, useMemo, useState } from 'react'
import { Modal, Empty } from 'antd'
import { PhotoItem } from '../../context/WatermarkBatchContext'
import useImageProcessUrl from '../../hooks/useImageProcessUrl'
import './FailedPhotosModal.scss'

interface FailedPhotosModalProps {
  visible: boolean
  photos: PhotoItem[]
  onClose: () => void
}

const FailedPhotosModal: React.FC<FailedPhotosModalProps> = ({
  visible,
  photos,
  onClose
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const { buildThumbUrl, buildProcessedUrl } = useImageProcessUrl()

  const THUMB_WIDTH = 96
  const PREVIEW_WIDTH = 800

  useEffect(() => {
    if (visible) {
      setActiveIndex(0)
    }
  }, [visible, photos.length])

  const normalizedPhotos = useMemo(() => {
    return photos.map((photo) => ({
      ...photo,
      previewUrl: buildProcessedUrl(
        photo.smallURL || photo.url || '',
        PREVIEW_WIDTH,
        85
      ),
      thumbUrl: buildThumbUrl(photo.smallURL || photo.url || '', THUMB_WIDTH)
    }))
  }, [photos, buildThumbUrl, buildProcessedUrl])

  const currentPhoto = normalizedPhotos[activeIndex]

  return (
    <Modal
      open={visible}
      title={`提取失败照片（${photos.length}）`}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      width={760}
      className="failed-photos-modal"
    >
      {normalizedPhotos.length === 0 ? (
        <div className="failed-photos-empty">
          <Empty description="暂无提取失败照片" />
        </div>
      ) : (
        <div className="failed-photos-content">
          <div className="failed-photos-list">
            <div className="failed-photos-list-inner">
              {normalizedPhotos.map((photo, index) => (
                <button
                  key={`${photo.seq}-${index}`}
                  type="button"
                  className={`failed-photos-item${
                    index === activeIndex ? ' is-active' : ''
                  }`}
                  onClick={() => setActiveIndex(index)}
                >
                  <img
                    src={photo.thumbUrl}
                    alt="缩略图"
                    className="failed-photos-thumb"
                  />
                  <span className="failed-photos-tag">提取失败</span>
                </button>
              ))}
            </div>
          </div>

          <div className="failed-photos-preview">
            {currentPhoto?.previewUrl ? (
              <img
                src={currentPhoto.previewUrl}
                alt="提取失败照片"
                className="failed-photos-preview-img"
              />
            ) : (
              <div className="failed-photos-preview-empty">无可预览图片</div>
            )}
            <div className="failed-photos-reason">
              {currentPhoto?.errorMsg ||
                currentPhoto?.show_reason ||
                currentPhoto?.reason ||
                '水印提取失败'}
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default FailedPhotosModal
